export default {
  Blizzard: 'Снежная буря',
  Frostbite: 'Обморожение',
  FrostTrap: 'Морозная ловушка',
  IceBlock: 'Ледяной блок',
  IceSpikes: 'Ледяные шипы',
  IceWall: 'Стена льда',
  IceWeapon: 'Ледяное оружие',
  Icing: 'Оледенение',
  Tsunami: 'Цунами',
  Waterfall: 'Водопад',
  IceArrow: 'Ледяная стрела',
  IceArmor: 'Ледяная броня',
};
